<!--page starts-->
<section class="page-wrapper">
    <div class="login-hero-section margin-top-152 cf">
        <div class="container">
           <div class="login-hero-detail">
           	   <div class="login-hero-top-section">
                  <a href="#"><img src="assets/images/ic-logo-new.png"></a>
               </div>
               <div class="login-hero-bottom-section">
                   <div class="login-hero-bottom-left">
                       <h2>Login</h2>
                       <form class="login-form" #loginForm="ngForm" (ngSubmit)="doLogin(loginForm)">
                       
                        <http-message [type]="'error'" [data]="loginError" *ngIf="loginError"
                           class="err-msg-block"></http-message>
                           <div class="login-input-box">
                                <app-form-field validation="required" name="email" [(ngModel)]="loginRequest.email" class="app-group">
                                    <input appFieldInput type="text" placeholder="User Name">
                                </app-form-field>
                           </div>
                           <div class="login-input-box">
                                <app-form-field validation="required" name="password" [(ngModel)]="loginRequest.password" class="app-group">
                                    <input appFieldInput type="password" placeholder="Password">
                                </app-form-field>
                           </div>
                           <div class="login-btn">
                            <button type="submit">LOGIN</button>
                               <!-- <a href="javascript:void(0)"></a> -->
                           </div>
                           <div class="lost-your-password">
                               <a routerLink="/forgot">Lost your Password?</a>
                           </div>
                       </form>
                   </div>
                   <div class="login-hero-bottom-right">
                       <h2>Register</h2>
                       <!-- <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, </p> -->
                       <p>&nbsp;<br/>&nbsp;</p>
                       <div class="create-account-btn">
                           <a routerLink="/register">Create an account</a>
                       </div>
                   </div>
               </div>
           </div>
        </div>
        <div class="login-hero-overlay"></div>
    </div>
</section><!-- page ends-->